module.exports = __webpack_public_path__ + "img/冻雨.a8074636.png";